export default "__VITE_ASSET__3c9ffa59__"